import { uniq } from 'lodash';

import { PortApiInterface } from '@/types/api-types';

import { getPreferredIdentifier } from '../helpers';

type PortMapping = {
  [key: string]: string;
};

const unknownPorts: PortMapping = {
  AUFIS: 'AUBNE', // Fishermens Island / Brisbane
  AUBTB: 'AUSYD', // Sydney/Botany Bay
  AUPBT: 'AUSYD', // Sydney/Port Botany
  CNNBG: 'CNNGB', // Ningbo
  CNSGH: 'CNSHG', // Shanghai
  CNTXG: 'CNTSN', // Tianjin
  MATNG: 'MAPTM', // Tanger Med
  NGLOS: 'NGAPP', // Lagos / Apappa
  KRBNP: 'KRPUS', // Busan New Port / Busan
  PAPTY: 'PAROD', // Panama City / Parod -- @TODO review
  NLMSV: 'NLRTM', // Rotterdam MAASVLAKTE / Rotterdam -- @TODO review (subport)
};

// Maps unknown Port codes to known FLUENT codes
// This is hopefully a temporary fix until the backend can add its own matchings
export const handleUnknownPortCodes = (portCodes: string[]): string[] => {
  const updatedCodes = portCodes.map((code) => {
    const mappedCode = unknownPorts[code];
    return mappedCode !== undefined ? mappedCode : code;
  });
  return uniq(updatedCodes);
};

export const handleUnknownPortCode = (portCode?: string): string => {
  if (!portCode) return '';
  const mappedCode = unknownPorts[portCode];
  return mappedCode !== undefined ? mappedCode : portCode;
};

/**
 * Strips out FLuent specific node data and returns basic Port Info
 */
export const cleanPortsData = (ports?: PortApiInterface[]) => {
  if (!ports) return [];

  return ports.map((port) => {
    const { id, name, type, ids, location, country } = port;
    const preferredId = getPreferredIdentifier(ids);

    return {
      id: preferredId ? `${preferredId.type} ${preferredId.value}` : id,
      name,
      type,
      ids,
      location,
      country,
    };
  });
};
